var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"viewBox":_vm.viewBox,"width":_vm.size,"height":_vm.size,"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.paths),function(path,index){return _c('path',{key:index,attrs:{"d":path.d,"fill":path.fill}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }